<div class="block min-h-dvh">
  <router-outlet />
</div>
